export const isFocused = element => element === document.activeElement;

export const handleTabKeyPress = (firstFocusElement, lastFocusElement, e) => {
    if (e.shiftKey && document.activeElement === firstFocusElement) {
        e.preventDefault();
        lastFocusElement.focus();
    } else if (!e.shiftKey && document.activeElement === lastFocusElement) {
        e.preventDefault();
        firstFocusElement.focus();
    }
};

export const openOnEnterKeyPressedOnDropdown = (reactRef, dropdown, isAltForm = false) => event => {
    if (event.key === 'Enter' && isFocused(dropdown)) {
        // open dropdowm
        reactRef.current.handleMouseDown({
            type: 'keydown',
            stopPropagation: () => {},
            preventDefault: () => {},
        });
        const chosenOptions = dropdown.querySelectorAll('.Dropdown-option');
        if (chosenOptions.length !== 0) {
            chosenOptions.forEach(option => {
                option.setAttribute('tabindex', '0');
            });

            if (isAltForm) {
                chosenOptions[0].setAttribute('tabindex', '-1');
                chosenOptions[1].focus();
            } else {
                chosenOptions[0].focus();
            }
        }
    } else if (event.key === 'Enter' && reactRef.current?.state.isOpen === true) {
        event.target.click();
    } else if (event.key === 'Tab' && reactRef.current?.state.isOpen === true) {
        const chosenOptions = dropdown.querySelectorAll('.Dropdown-option');
        const firstElement = isAltForm ? chosenOptions[1] : chosenOptions[0];
        const lastElement = chosenOptions[chosenOptions.length - 1];
        handleTabKeyPress(firstElement, lastElement, event);
    }
};
